











































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import { PageTitle } from '@questelservices/common-vue';
import { DxButton, DxPopup, DxLoadIndicator } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import { MatterWorkMatterDto } from '../models/matter-work/MatterWorkMatterDto';
import MatterWorkLineItems, { MatterWorkLineItemsDialogState } from '../components/matter-work/matter-work-line-items.vue';
import { MatterWorkTypeEnum } from '../models/matter-work/MatterWorkTypeEnum';
import { PhaseTypeDto } from '../models/PhaseTypeDto';
import { ManualCodeInvoiceLineItemDto } from '@/models/ManualCodeInvoiceLineItemDto';
import { KeyMap } from '@/models/KeyMap';
import { PhaseNames } from '@/models/PhaseNames';
import OrderSetupDialog from '../components/matter-work/phase-assignment_order-setup-dialog.vue';
import { UserSetting, UserSettingReportName, UserSettingName, OrderingMethod } from '@/models/UserSetting';
import FilingType from '../components/filing-type.vue';
import { ChangeFilingTypeDto, FilingTypeDto } from '../models/FilingTypeDto';
import { FilingTypeService } from '../service/FilingTypeService';
import { UserSettingFilter } from '@/models/UserSettingFilter';
import { UserService } from '@/service/UserService';
import _, { xor } from 'lodash';
import { FeeSheetRuleDto } from '@/models/Fees/FeeSheetRuleDto';
import { FeeSheetDto } from '@/models/Fees/FeeSheetDto';
import notify from 'devextreme/ui/notify';
import { alert } from 'devextreme/ui/dialog';
import ChargeSummary from '../components/auditor/charge-summary.vue';
import AgentFeeSheetTable from '../components/auditor/agent-fee-sheet-table.vue';
import { FeeSheetsService } from '@/service/FeeSheetsService';
import { AgentDto } from '../models/agent/AgentDto';
import { ClientDto } from '../models/client/ClientDto';
import { BatchService } from '@/service/BatchService';
import { FeeBudgetRuleDto } from '@/models/fee-budgets/FeeBudgetRuleDto';
import { AuditingService } from '@/service/AuditingService';
import { BatchEventTypeDateDto } from '@/models/batch/BatchEventTypeDateDto';
import { BatchEventTypeEnum, BatchEventDateTypeEnum } from '@/models/batch/BatchEventTypeEnum';
import DateTime from '../utilities/DateTime';
import MatterWorkNavigator from '@/components/matter-work/matter-work-navigator.vue';
import { getModule } from 'vuex-module-decorators';
import store from '@/store';
import MatterWorkModule from '@/store/MatterWorkModule';
import { ExecutiveSummaryRequestEnum } from '@/models/ExecutiveSummaryRequestEnum';

@Component({
  components: {
    PageTitle,
    DxButton,   
    MatterWorkLineItems,
    OrderSetupDialog,
    FilingType,
    DxPopup,
    DxLoadIndicator,
    ChargeSummary,
    AgentFeeSheetTable,
    MatterWorkNavigator
  },
  beforeRouteLeave: function (to,from,next) {
    let auditorPage: AuditorPage = this as AuditorPage;
    auditorPage.$destroy();
    next();
  }
})
export default class AuditorPage extends Vue {
  $refs: Vue['$refs'] & {
    matterWorkLineItems?: MatterWorkLineItems;
    chargesummary?: ChargeSummary;    
    matterWorkNavigation?: MatterWorkNavigator;    
    agentFeeSheetTable?: AgentFeeSheetTable;
    
  } = {};

  private client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');
  private filingTypeService: FilingTypeService = new FilingTypeService();
  private userService: UserService = new UserService();

  private get agentFeeSheetTable(): AgentFeeSheetTable {
    return (this.$refs.agentFeeSheetTable as any);
  }

  private get lineItemDataGrid(): DevExpress.ui.dxDataGrid {
    return (((this.$refs.matterWorkLineItems as any).$refs.manualCodingDataGrid as any).$refs
      .dxDataGrid as any).instance;
  }

  private get matterWorkId(): Guid | undefined {
    return this.$route.params.id;
  }

  private get caseCount(): number | null {
    if(this.$route.query.cases) {
      let caseCount = parseInt(this.$route.query.cases as string);
      return caseCount;
    }
    return null;
  }

  private phaseTypes: PhaseTypeDto[] = [];
  private filingTypes: FilingTypeDto[] = [];
  private feeSheetRules: FeeSheetRuleDto[] = [];
  private feeBudgetRules: FeeBudgetRuleDto[] = [];

  clientId: Guid = '';
  clientDto: ClientDto = {
    ClientId: '',
    ClientName: ''
  }

  agentFeeSheetProcessed: boolean = false; 
  feeSheetService: FeeSheetsService;
  agents: AgentDto[] = [];
  agentFeeSheets: FeeSheetDto[] = [];
  matterWorkType: MatterWorkTypeEnum = MatterWorkTypeEnum.Auditing;
  private showIndicatorForReleaseMatter: boolean = false;
  private showIndicatorForReleaseMatterButton: boolean = false;  
  private buttonText: string = "Release Claims";
  private gridRefresher: boolean = true;
  private gridRefreshTimeout: any = null;

  @Watch("selectedMatterId")
  gridRefresh() {
    this.gridRefresher = false;
    if(this.gridRefreshTimeout) {
      clearTimeout(this.gridRefreshTimeout);
    }
    this.gridRefreshTimeout = setTimeout(()=>{this.gridRefresher = true;}, 250);
  }
  matterWorkModule = getModule(MatterWorkModule, store);

  private get selectedFilingType(): FilingTypeDto | undefined {
    if(this.selectedMatter) {
      return this.filingTypes.find(t => t.FilingTypeId === this.selectedMatter!.FilingTypeId);
    }
  }

  get getClientId() { 
    if(this.selectedMatter) {
      return this.selectedMatter.ClientId;
    }
  }
  
  private get selectedMatterId() {
    return this.matterWorkModule.selectMatterId;
  }

  private get selectedMatter() {
    return this.matterWorkModule.selectMatter;
  }
 
  // This gets the status of the left sidebar
  private get sidePanelIsOpen() {
    return (this.$root.$children[0].$children[1] as any).menuOpened;    
  }

  private isAutoSkip : boolean = false;

  @Watch('selectedMatter')
  onSelectedMatterChanged() {
    this.linesSetByCodeAll = [];
    if(this.selectedMatter) {
      this.clientId = this.selectedMatter.ClientId
      this.clientDto = {
        ClientId: this.selectedMatter.ClientId,
        ClientName: this.selectedMatter.ClientName
      } 
    }
  }
  
  private auditingService: AuditingService;
  batchService: BatchService;
  clientIdWatcher: any; 

  get batchIdsOfCurrentBatch() {
    return this.matterWorkModule.activeBatches || [];
  }

  private showingReleaseMatters: boolean = false;
  private showingReadyToReport: boolean = false;
  private reportAvailableScheduledDate: Date | null = null;
  pageType: MatterWorkTypeEnum = MatterWorkTypeEnum.Auditing;    

  get isDialogOpen() {
    return this.showingSetupDialog || this.showingNotes || this.showingContextMenu || this.showingColumnChooser ||
      this.showingInfractions || this.showingInfractionsPopover || this.showingReleaseMatters || this.showingPhaseHistory;
  }

  constructor() {
    super();
    this.feeSheetService = new FeeSheetsService('/api/FeeSheets');
    this.batchService = new BatchService();
    this.auditingService = new AuditingService();
  }
  
  created() {
    document.addEventListener('keyup', this.onKeyup);
    this.loadData();
  }

  destroyed() {
    document.removeEventListener('keyup', this.onKeyup);
    this.matterWorkModule.setSelectedMatterId(null);
    this.matterWorkModule.setSelectedMatter(null);
    this.matterWorkModule.setActiveBatchIds([]);
  }

  beforeDestroy() {
    if(this.$refs.matterWorkLineItems) {
      this.$refs.matterWorkLineItems.$destroy();
    }

    if(this.$refs.matterWorkNavigation) {
      this.$refs.matterWorkNavigation.$destroy();
    }

    if(this.$refs.chargesummary) {
      this.$refs.chargesummary.$destroy();
    }

    this.gridRefresher=false;
    this.agents.length = 0;
  }

  onAutoSkipChanged(data: boolean) {
    this.isAutoSkip = data;
  }  

  onKeyup(event: KeyboardEvent) {
    if (this.isDialogOpen) {
      return;
    }

    //if target of event is a text editor disable keyboard shortcuts
    if ((event.target as any ).className == "dx-texteditor-input") {
      return;
    }

    event.preventDefault();
    
    if (event.ctrlKey) {
      switch (event.keyCode) {
        case KeyMap.one:
        case KeyMap.numPadOne:
          this.assignPhaseToSelection(PhaseNames.misc,event);
          break;
        case KeyMap.two:
        case KeyMap.numPadTwo:
          this.assignPhaseToSelection(PhaseNames.publication,event);
          break;
        case KeyMap.three:
        case KeyMap.numPadThree:
          this.assignPhaseToSelection(PhaseNames.postGrantReview,event);
          break;
        case KeyMap.four:
        case KeyMap.numPadFour:
          this.assignPhaseToSelection(PhaseNames.validation,event);
          break;
        case KeyMap.five:
        case KeyMap.numPadFive:
          this.assignPhaseToSelection(PhaseNames.pph,event);
          break;
        case KeyMap.six:
        case KeyMap.numPadSix:
          this.assignPhaseToSelection(PhaseNames.noveltySearch,event);
          break;
        case KeyMap.fSlash:
        case KeyMap.numPadFSlash:
          this.assignPhaseToSelection(PhaseNames.idsCopies,event);
          break;
      }
    } else {
      switch (event.keyCode) {
        case KeyMap.leftArrow:
          (this.$refs.matterWorkNavigation as any).prevCase();
          break;
        case KeyMap.rightArrow:
          (this.$refs.matterWorkNavigation as any).nextCase();
          break;
        case KeyMap.upArrow:              
          (this.$refs.matterWorkNavigation as any).prevActiveCase();
          break;
        case KeyMap.downArrow:              
          (this.$refs.matterWorkNavigation as any).confirmAllMatters();
          break;
        case KeyMap.one:
        case KeyMap.numPadOne:
          this.assignPhaseToSelection(PhaseNames.drafting,event);
          break;
        case KeyMap.two:
        case KeyMap.numPadTwo:
          this.assignPhaseToSelection(PhaseNames.filing,event);
          break;
        case KeyMap.three:
        case KeyMap.numPadThree:
          this.assignPhaseToSelection(PhaseNames.exam,event);
          break;
        case KeyMap.four:
        case KeyMap.numPadFour:
          this.assignPhaseToSelection(PhaseNames.prosecution,event);
          break;
        case KeyMap.five:
        case KeyMap.numPadFive:
          this.assignPhaseToSelection(PhaseNames.grant,event);
          break;
        case KeyMap.six:
        case KeyMap.numPadSix:
          this.assignPhaseToSelection(PhaseNames.oneSixOneOneSixTwo,event);
          break;
        case KeyMap.seven:
        case KeyMap.numPadSeven:
          this.assignPhaseToSelection(PhaseNames.appeal,event);
          break;
        case KeyMap.eight:
        case KeyMap.numPadEight:
          this.assignPhaseToSelection(PhaseNames.subsequentApplications,event);
          break;
        case KeyMap.nine:
        case KeyMap.numPadNine:
          this.assignPhaseToSelection(PhaseNames.annuity,event);
          break;
        case KeyMap.fSlash:
        case KeyMap.numPadFSlash:
          this.assignPhaseToSelection(PhaseNames.ids,event);
          break;
        case KeyMap.period:
        case KeyMap.numPadPeriod:
          let selectedRows = this.lineItemDataGrid.getSelectedRowsData() as ManualCodeInvoiceLineItemDto[];
          if (selectedRows.length === 1) {
            this.openNotes();
          } else if (selectedRows.length > 1) {
            notify('Cannot open notes with multiple lines selected.','info', 1000);
          }
          break;
      }
    }
  }

  async loadRequiredData() {
    this.phaseTypes = await this.client.get<PhaseTypeDto[]>('/api/phasetype/all');
  }

  async loadData() {
    this.filingTypeService.getTypes().then(types => {
      this.filingTypes = types;
    });

    this.getAutoskipPreference().then(preference => {
      this.isAutoSkip = preference;
    });

    this.client.get(`/api/MatterWorks/${this.matterWorkId}/fee-sheet-rules`).then(rules => {
      this.feeSheetRules = rules;
    });

    this.client.get<FeeBudgetRuleDto[]>(`/api/MatterWorks/${this.matterWorkId}/fee-budget-rules`).then(rules => {
      this.feeBudgetRules = rules;
    });

    // Phase types and matters are required for the navigator / page to load, other data can be loaded asyncronously
    await this.loadRequiredData();
  }

  updateLineItems(lineItems: ManualCodeInvoiceLineItemDto[], skip: boolean = true): void {
    if(this.$refs.matterWorkLineItems) {
      this.$refs.matterWorkLineItems.updateLineItems(lineItems);
    }
  }

  private linesSetByCodeAll: Guid[] = [];

  async assignPhaseToSelection(phaseTypeId: number | null, event: KeyboardEvent | null): Promise<void> {     
    let selectedRows = this.lineItemDataGrid.getSelectedRowsData() as ManualCodeInvoiceLineItemDto[];
    let lineItemIds: Guid[] = [];

    // If no line items selected, assign phase to all line items in latest batch
    if (selectedRows.length === 0) {
      if (this.linesSetByCodeAll.length > 0) {
        lineItemIds = this.linesSetByCodeAll;
      } else if (this.$refs.matterWorkLineItems && this.$refs.matterWorkLineItems.activeBatchIds) {
        lineItemIds = this.$refs.matterWorkLineItems.lineItems
          .filter(li => this.batchIdsOfCurrentBatch.some(b => b === li.BatchId) && li.LastAssignedById == null)
          .map(li => li.InvoiceLineItemId);
        this.linesSetByCodeAll = lineItemIds;
      }

      if (this.$refs.matterWorkLineItems) {
        selectedRows = this.$refs.matterWorkLineItems.lineItems.filter(li => lineItemIds.some(id => li.InvoiceLineItemId == id));
      }      

    } else {
      this.linesSetByCodeAll = [];
      selectedRows.forEach(row => {
        lineItemIds.push(row.InvoiceLineItemId);
      });
    }

    if (lineItemIds.length) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }

      this.lineItemDataGrid.clearSelection();
             
      let oldRows: ManualCodeInvoiceLineItemDto[] = _.cloneDeep(selectedRows);

      let assignedPhaseTypeId = phaseTypeId == null ? -1 : phaseTypeId;
      let assignedPhaseName = phaseTypeId == null ? 'Unassigned' : this.phaseTypes.filter(p => p.PhaseTypeId == phaseTypeId)[0].PhaseName;    

      selectedRows.forEach(li => {
          li.AssignedPhaseTypeId = assignedPhaseTypeId;
          li.AssignedPhaseName = assignedPhaseName;
          li.Confirmed = true;
        });    

      let updatedMatter = this.selectedMatter;
      this.updateLineItems(selectedRows, false);
      this.$refs.matterWorkNavigation!.updateMatterList(this.selectedMatter!.MatterId);

      await this.client.getPostData<ManualCodeInvoiceLineItemDto[]>('/api/manualcoding/assignphase', {
        phaseTypeId: phaseTypeId,
        lineItems: lineItemIds
      })
      .then(results => {
          // update the line items with any additional information from the backend (LastAssignedById, ConfirmedById, etc)
        // only update the line items if the matter hasn't been changed after phase assignment
        if (this.selectedMatterId == updatedMatter!.MatterId) {
          this.updateLineItems(results, false);
          this.$refs.matterWorkNavigation!.updateMatterList(this.selectedMatter!.MatterId);
        }
      })
      .catch(_ => {
        alert(`Error assigning phase to line item(s) for matter ${updatedMatter!.ClientMatterId}.`, "Error");
        if (this.selectedMatterId == updatedMatter!.MatterId) {
          //revert rows if an error occurs
          this.updateLineItems(oldRows, false);        
          this.$refs.matterWorkNavigation!.updateMatterList(this.selectedMatter!.MatterId);
        }    
      });
    }
  }

  setExemptRowToSelection(isExemptRow: boolean) {
    let selectedRows = this.lineItemDataGrid.getSelectedRowsData() as ManualCodeInvoiceLineItemDto[];
    let lineItemIds: Guid[] = [];

    // If no line items selected, assign phase to all line items in latest batch
    if (selectedRows.length === 0) {     
      if (this.$refs.matterWorkLineItems && this.$refs.matterWorkLineItems.activeBatchIds) {
        let activeBatchIds = this.$refs.matterWorkLineItems.activeBatchIds;
        lineItemIds = this.$refs.matterWorkLineItems.lineItems
          .filter(li => activeBatchIds.some(b => b === li.BatchId))
          .map(li => li.InvoiceLineItemId);
      }
    } else {      
      selectedRows.forEach(row => {
        lineItemIds.push(row.InvoiceLineItemId);
      });
    }

    if (lineItemIds.length) {
      this.lineItemDataGrid.clearSelection();

      this.client.getPostData<ManualCodeInvoiceLineItemDto[]>('/api/manualcoding/updateexemptrow', {
        isExemptRow: isExemptRow,
        lineItems: lineItemIds
      }).then(results => {
        this.updateLineItems(results, false);
      });
    }
  }

  matterWorkLineItemsDialogStateChanged(e: MatterWorkLineItemsDialogState) {
    this.showingNotes = e.showingNotes;
    this.showingContextMenu = e.showingContextMenu;
    this.showingColumnChooser = e.showingColumnChooser;
    this.showingInfractions = e.showingInfractions;
    this.showingInfractionsPopover = e.showingInfractionsPopover;
    this.showingPhaseHistory = e.showingPhaseHistory;
  }

  auditMatter() {  
    if(this.selectedMatter) {
      this.selectedMatter.IsStillAuditing = true;
      let cloneMatter=_.clone(this.selectedMatter);
      this.client.postJson(`/api/auditing/${this.selectedMatterId}`, {})
        .then(result => {
          this.displayErrorAuditingMatter(cloneMatter, result.Data === false ? false : true);
        })
        .catch(err => {
          this.displayErrorAuditingMatter(cloneMatter, false);
        });
    }
  }

  displayErrorAuditingMatter(auditingMatter: MatterWorkMatterDto, isSuccessfulResult: boolean) {
    this.$refs.matterWorkNavigation!.confirmAuditMatter(auditingMatter.MatterId,isSuccessfulResult);
    if (!isSuccessfulResult) {
      if (this.showingReleaseMatters) {
        this.showingReleaseMatters = false;
      }
      let message = `An error occurred when auditing matter ${auditingMatter.ClientMatterId} ${auditingMatter.CountryCode}.`;
      alert(message, 'Error');
    }

    let isForRelease = this.$refs.matterWorkNavigation!.checkForRelease();
    if(isForRelease) {
      this.showingReleaseMatters = true;
    }
  }

  nextActiveCase() {
    if(this.$refs.matterWorkNavigation) {
      this.$refs.matterWorkNavigation.nextActiveCase()
    }    
  }

  lineItemsLoaded(lineItems: ManualCodeInvoiceLineItemDto[]) {   
    if (lineItems && lineItems.length) {
      this.agents = _.uniqBy(lineItems, item => item.AgentName)
                    .map(function(item): AgentDto {
                      return { AgentName: item.AgentName, AgentId: item.AgentId };
                    });    
      this.updateFeeSheetsStatuses();  

      if(this.selectedMatter) {    
        this.selectedMatter.LineItems = lineItems;    
      }  
    }
  }

  async updateFeeSheetsStatuses() {
    if(this.getClientId) {     
      this.agentFeeSheetTable.processGettingAgentFeeSheets();
    }
  }

  autoSkipPref: UserSettingFilter = {
            reportName: UserSettingReportName.UserPreference,
            name : UserSettingName.AutoSkip
        }
        
  getAutoskipPreference(): Promise<any> {
    return this.userService.getUserSettingsWithFilter(this.autoSkipPref)
            .then((result: UserSetting[]) => {
                let autoSkip = _.find(result, (item:UserSetting) => {
                                    return item.ReportName === UserSettingReportName.UserPreference &&
                                            item.Name === UserSettingName.AutoSkip;
                                }) || false;

                return (autoSkip ? autoSkip.Value == 'true': false);
            })
            .catch((err: any) => false)
  }


  public showingSetupDialog: boolean = false;
  
  private showingNotes: boolean = false;
  private showingContextMenu: boolean = false;
  private showingColumnChooser: boolean = false;
  private showingInfractions: boolean = false;
  private showingInfractionsPopover: boolean = false;
  private showingPhaseHistory: boolean = false;

  openSetupDialog(): void {
    this.showingSetupDialog = true;
  }

  hidingDialog() {
    this.showingSetupDialog = false;
  }

  async caseDisplayOrderUpdated(settings: UserSetting[]) {
    const orderMethod = settings.filter(s => s.Name === UserSettingName.OrderingMethod && s.Value === OrderingMethod.ByServiceCost); 

    (this.$refs.matterWorkNavigation as any).refreshCaseDisplayOrder(settings);
  }

  selectColumns() {
    this.lineItemDataGrid.showColumnChooser();
    this.showingColumnChooser = true;
  }

  private changeFiling(dto: ChangeFilingTypeDto) {
    this.selectedMatter!.FilingTypeId = dto.FilingType;
    this.$root.$emit('updatenavmatters', ExecutiveSummaryRequestEnum.PhaseAnalysisItem)
  }

  private openNotes() {
    (this.$refs.matterWorkLineItems as any).openNotesKeyboard();
  }

  private async releaseMatters() {    
    this.showIndicatorForReleaseMatterButton = true;    
    this.buttonText = "Releasing Claims";
    await this.client.sendRequest(HttpMethodEnum.Post, `/api/matterworks/${this.matterWorkId}/release-matters`)
      .finally(() => {
        this.showIndicatorForReleaseMatterButton = false;
      });
    
    if(this.clientId) {
      let auditCompleted = await this.auditingService.auditCompleted(this.clientId).then(result =>{
        return result;
      });
      if(auditCompleted.Value) {      
        const dto: BatchEventTypeDateDto = { 
          BatchEventType: BatchEventTypeEnum.ReportAvailable,
          BatchEventDateType: BatchEventDateTypeEnum.ScheduledDate
        };

      try {        
        let date = await this.batchService.getBatchEventTypeDate(this.clientId, dto);        
        if(date.Data.reportAvailableDate !== null) {
          this.reportAvailableScheduledDate = (this.$options.filters as any).moment(date,"MM-DD-YYYY");
          this.showingReadyToReport = true;
        }
        else {          
          notify('Report Available Batch Event not found.','error', 10000);
          return;
        }
      } catch (error) {        
        notify('Error occured while Releasing Matters.','error', 10000);
        return;
      }          
      }
      else {            
        this.closeReleaseMatters();      
        this.$router.push({ name: 'auditing-work' });
      }        
    }
    this.closeReleaseMatters();
  }

  private async setClearedForReporting() {
    if(this.getClientId) {
      await this.batchService.setReadyForReporting(this.getClientId);
      this.showingReadyToReport = false;
      this.$router.push({ name: 'auditing-work' });
    }
  }

  private closeReleaseMatters() {
    this.showingReleaseMatters = false;
  }

  private closeClearedForReport() {
    this.showingReadyToReport = false;
  }

  private feeSheetUpdated() {
    this.loadData();
    this.lineItemDataGrid.refresh();    
  }
}
